export { elementContainsAttribute } from '@fluentui/dom-utilities';
//# sourceMappingURL=elementContainsAttribute.js.map